import { toHttpError } from "@/utils/api"

export const BILL_PDF_UPLOAD_SESSION_PATH =
  "/api/v1/data_manager/bill_pdf_upload_sessions"

/**
 * Runs a bill PDF upload session request, normalizing failures to HttpError.
 */
export const requestBillPdfUploadSession = async <TResponse>(
  request: () => Promise<TResponse>
): Promise<TResponse> => {
  try {
    return await request()
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}
